import React from 'react'
import { Route } from 'react-router-dom'
import AccountWidget from './widgets/Account'
import ForestWidget from './widgets/Forest'
import GlobeWidget from './widgets/Globe'
import LeaderboardWidget from './widgets/Leaderboard'
import AchievementsWidget from './widgets/Achievements'
import VitaminWellBanner from './widgets/VitaminWell/VitaminWellBanner'
import VitaminWellForest from './widgets/VitaminWell/VitaminWellForest'
import GlobalTreeInitiativeBanner from './widgets/GlobalTreeInitiative/GlobalTreeInitiativeBanner'

const App = () => (
    <div>
        <Route path="/globe" exact component={GlobeWidget} />
        <Route path="/leaderboard/:uid?" exact component={LeaderboardWidget} />
        <Route path="/forest/:puid?" exact component={ForestWidget} />
        <Route path="/account/:status?" exact component={AccountWidget} />
        <Route path="/myachievements/:date/:cid?/:uid?" exact component={AchievementsWidget} />

        {/* TopRun + VitaminWell specifics */}
        <Route path="/vwbanner/:puid?/:offset?" exact component={VitaminWellBanner} />
        <Route path="/vwforest/:puid?/:offset?" exact component={VitaminWellForest} />

        <Route path="/gtibanner/:puid?/:offset?" exact component={GlobalTreeInitiativeBanner} />
    </div>
)

export default App
